import { render } from "./MeusAvisosView.vue?vue&type=template&id=f634d674&scoped=true"
import script from "./MeusAvisosView.vue?vue&type=script&lang=js"
export * from "./MeusAvisosView.vue?vue&type=script&lang=js"

import "./MeusAvisosView.vue?vue&type=style&index=0&id=f634d674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f634d674"]])

export default __exports__